import type { EventCategory } from './base';

export const OrderEvents = {
  CUSTOMER_ORDERS_COMMITTED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekId: '' as string,
      mealOrderId: '' as string,
      orderCountForWeek: 0 as number,
      firstOrderForWeek: false as boolean,
      weekdayCount: 0 as number,
      role: '' as string,
      canteenId: '' as string | undefined,
      decisionsMadeCount: 0 as number,
    },
  },
  MEAL_ORDER_CREATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekId: '' as string,
      mealOrderId: '' as string,
      role: '' as string,
      attendancePatternApplied: false as boolean,
      decisionsMadeCount: 0 as number,
    },
  },
  ORDER_SLOT_DECISION_UPDATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      orderSlotId: '' as string,
      mealOrderId: '' as string,
      menuSlotId: '' as string,
      weekday: 0 as number,
      daypart: '' as string,
      decision: '' as string,
      trigger: '' as string,
      menuSlotKey: '' as string,
    },
  },
  ORDER_LINE_SELECTION_UPDATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      orderLineId: '' as string,
      orderSlotId: '' as string,
      course: '' as string,
      status: '' as string,
      mealId: '' as string | null | undefined,
      menuItemId: '' as string | null | undefined,
      quantity: 0 as number,
      menuSlotId: '' as string,
      menuSlotKey: '' as string,
      weekday: 0 as number,
      daypart: '' as string,
    },
  },
  MEAL_ORDER_CANCELLED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      mealOrderId: '' as string,
      menuWeekId: '' as string | undefined,
      role: '' as string,
    },
  },
  ORDER_SLOT_REMOVED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      orderSlotId: '' as string,
      mealOrderId: '' as string,
      menuSlotId: '' as string,
    },
  },
  ORDER_LINE_REMOVED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      orderLineId: '' as string,
      orderSlotId: '' as string,
      menuItemId: '' as string | null | undefined,
      course: '' as string,
    },
  },
  MEAL_SELECTION_SAVED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      menuPlanId: '' as string,
      selectionsCount: 0 as number,
    },
  },
  MEAL_SELECTION_FAILED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      action: '' as 'meal_selection' | 'soup_toggle' | 'dessert_toggle' | 'skip_day' | 'unskip_day',
      message: '' as string,
      menuPlanId: '' as string | undefined,
      dayKey: '' as string,
      digest: '' as string | undefined,
    },
  },
} as const;
